import { atom } from "jotai";

export const myRoleAtom = atom("");
export const myPrivilegesAtom = atom([]);
// Privilèges retirés au rôle (privilegesOff de roles/mine) : RoleStyle masque
// en CSS les éléments [data-priv] correspondants, le menu latéral les filtre.
export const myHiddenPrivilegesAtom = atom([]);
